import React, { useState } from 'react';
import {  Pencil, Pause, Ban, MoreVertical } from 'lucide-react';
import { Ticket, Tag, Wallet, Clock3, Receipt } from 'lucide-react';
import '../CouponDetails/CouponDetails.css';
import VoucherOverviewTab from './tabs/VoucherOverviewTab';
import VoucherRedemptionTab from './tabs/VoucherRedemptionTab';
import VoucherUsageTab from './tabs/VoucherUsageTab';
import VoucherRulesTab from './tabs/VoucherRulesTab';
import VoucherBudgetTab from './tabs/VoucherBudgetTab';
import CouponActivityTab from '../CouponDetails/tabs/CouponActivityTab';

  const couponData = {
    id: 'VCH-001',
    name: 'VIP Exclusive Voucher',
    status: 'Active',
  };

  const statCards = [
    { icon: Ticket, iconBg: '#F5A623', label: 'Total Redemptions', value: '1,248' },
    { icon: Tag, iconBg: '#7E1BAD', label: 'Total Discount Given', value: '249,600 EGP' },
    { icon: Wallet, iconBg: '#1F2937', label: 'Remaining Budget', value: '750,400 EGP' },
    { icon: Clock3, iconBg: '#3B82F6', label: 'Usage Rate', value: '24.96%' },
    { icon: Receipt, iconBg: '#6B7280', label: 'Redemption Value', value: '1,998,400 EGP' },
  ];

  const TABS = [
    { key: 'overview', label: 'Overview' },
    { key: 'redemptions', label: 'Redemptions' },
    { key: 'usage', label: 'Assignment & Usage' },
    { key: 'rules', label: 'Rules & Eligibility' },
    { key: 'budget', label: 'Budget & Funding' },
    { key: 'activity', label: 'Activity Log' },
  ];

export default function VoucherDetails() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="cd-page">
      <div className="cd-overview">
        {/* Header: title + status + actions */}
        <div className="cd-header-row">
          <div className="cd-title-block">
            <div className="cd-title-line">
              <h1 className="cd-title">{couponData.name}</h1>
              <span className="cd-status-badge">
                <span className="cd-status-dot" />
                {couponData.status}
              </span>
            </div>
            <span className="cd-code">{couponData.id}</span>
          </div>

          <div className="cd-actions">
            <button className="cd-btn cd-btn-outline">
              <Pencil size={16} /> Edit
            </button>
            <button className="cd-btn cd-btn-outline">
              <Pause size={16} /> Pause
            </button>
            <button className="cd-btn cd-btn-danger">
              <Ban size={16} /> Disable
            </button>
            <button className="cd-btn cd-btn-icon">
              <MoreVertical size={18} />
            </button>
          </div>
        </div>

        {/* Stat cards */}
        <div className="cd-stats-row">
          {statCards.map((card, i) => {
            const Icon = card.icon;
            return (
              <div className="cd-stat-card" key={i}>
                <div className="cd-stat-top">
                  <span
                    className="cd-stat-icon"
                    style={{ backgroundColor: card.iconBg }}
                  >
                    <Icon size={16} color="#fff" />
                  </span>
                  <span className="cd-stat-label">{card.label}</span>
                </div>
                <div className="cd-stat-value">{card.value}</div>
              </div>
            );
          })}
        </div>

        {/* Tabs */}
        <div className="cd-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              className={`cd-tab ${activeTab === tab.key ? "cd-tab-active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div className="cd-tab-content">
          {activeTab === "overview" && <VoucherOverviewTab />}
          {activeTab === "redemptions" && <VoucherRedemptionTab />}
          {activeTab === "usage" && <VoucherUsageTab />}
          {activeTab === "rules" && <VoucherRulesTab />}
          {activeTab === "budget" && <VoucherBudgetTab />}
          {activeTab === "activity" && <CouponActivityTab />}
        </div>
      </div>
    </div>
  );
}
